<script setup lang="ts">
import { availableXAggregations, type xAggregations } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'

const model = defineModel<xAggregations>({ default: 'mean' })
</script>

<template>
  <v-autocomplete
    v-model="model"
    prepend-icon="mdi-axis-x-arrow"
    :label="$t('chart_sharing.creator.customize.line_settings.aggregation.x_title')"
    variant="outlined"
    :items="availableXAggregations"
    :item-title="item => $t(`chart_sharing.creator.customize.line_settings.aggregation.${item}`)"
    :item-value="item => item"
  />
</template>
